module.exports = __webpack_public_path__ + "static/media/slider-phone-1.0f92af73.jpg";